import {
    MRT_GlobalFilterTextField as GlobalFilterTextField,
    MRT_GlobalFilterTextFieldProps,
    MRT_RowData,
} from 'material-react-table';
import { InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import { Dispatch, SetStateAction } from 'react';

interface UtmsGlobalFilterTextFieldProps<TData extends MRT_RowData> extends MRT_GlobalFilterTextFieldProps<TData> {
    globalFilter?: string;
    setGlobalFilter?: Dispatch<SetStateAction<string>>;
}

const UtmsGlobalFilterTextField = <TData extends MRT_RowData>({
    globalFilter,
    setGlobalFilter,
    table,
    ...props
}: UtmsGlobalFilterTextFieldProps<TData>) => {
    const globalFilterValue = globalFilter || table.getState().globalFilter;
    const handleClearGlobalFilter = () => {
        setGlobalFilter ? setGlobalFilter('') : table.setGlobalFilter('');
    };

    return (
        <GlobalFilterTextField
            slotProps={{
                input: {
                    sx: { height: 42, width: 224 },
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    endAdornment: globalFilterValue && (
                        <InputAdornment position="end">
                            <IconButton onClick={handleClearGlobalFilter} edge="end" size="small">
                                <ClearIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                },
            }}
            table={table}
            margin="dense"
            {...props}
        />
    );
};

export default UtmsGlobalFilterTextField;
